var map = {
	"./collections/en/brands/alter-eco/content": [
		38860,
		9,
		8860
	],
	"./collections/en/brands/alter-eco/content.tsx": [
		38860,
		9,
		8860
	],
	"./collections/en/brands/anian/content": [
		84375,
		9,
		4375
	],
	"./collections/en/brands/anian/content.tsx": [
		84375,
		9,
		4375
	],
	"./collections/en/brands/avocado-green-brands/content": [
		62947,
		9,
		2947
	],
	"./collections/en/brands/avocado-green-brands/content.tsx": [
		62947,
		9,
		2947
	],
	"./collections/en/brands/bather/content": [
		73401,
		9,
		3401
	],
	"./collections/en/brands/bather/content.tsx": [
		73401,
		9,
		3401
	],
	"./collections/en/brands/bee-keepers-naturals/content": [
		42909,
		9,
		2909
	],
	"./collections/en/brands/bee-keepers-naturals/content.tsx": [
		42909,
		9,
		2909
	],
	"./collections/en/brands/better-basics/content": [
		99442,
		9,
		9442
	],
	"./collections/en/brands/better-basics/content.tsx": [
		99442,
		9,
		9442
	],
	"./collections/en/brands/bio-raw/content": [
		62593,
		9,
		2593
	],
	"./collections/en/brands/bio-raw/content.tsx": [
		62593,
		9,
		2593
	],
	"./collections/en/brands/bloedstone/content": [
		4674,
		9,
		4674
	],
	"./collections/en/brands/bloedstone/content.tsx": [
		4674,
		9,
		4674
	],
	"./collections/en/brands/blueland/content": [
		87477,
		9,
		7477
	],
	"./collections/en/brands/blueland/content.tsx": [
		87477,
		9,
		7477
	],
	"./collections/en/brands/bondi-born/content": [
		9688,
		9,
		9688
	],
	"./collections/en/brands/bondi-born/content.tsx": [
		9688,
		9,
		9688
	],
	"./collections/en/brands/boyish/content": [
		47505,
		9,
		7505
	],
	"./collections/en/brands/boyish/content.tsx": [
		47505,
		9,
		7505
	],
	"./collections/en/brands/byo-long-beach/content": [
		61110,
		9,
		1110
	],
	"./collections/en/brands/byo-long-beach/content.tsx": [
		61110,
		9,
		1110
	],
	"./collections/en/brands/chopvalue/content": [
		76554,
		9,
		6554
	],
	"./collections/en/brands/chopvalue/content.tsx": [
		76554,
		9,
		6554
	],
	"./collections/en/brands/culthread/content": [
		44104,
		9,
		4104
	],
	"./collections/en/brands/culthread/content.tsx": [
		44104,
		9,
		4104
	],
	"./collections/en/brands/dear-survivor/content": [
		15424,
		9,
		5424
	],
	"./collections/en/brands/dear-survivor/content.tsx": [
		15424,
		9,
		5424
	],
	"./collections/en/brands/eclipse-coffee-roasters/content": [
		7718,
		9,
		7718
	],
	"./collections/en/brands/eclipse-coffee-roasters/content.tsx": [
		7718,
		9,
		7718
	],
	"./collections/en/brands/ecologyst/content": [
		84125,
		9,
		4125
	],
	"./collections/en/brands/ecologyst/content.tsx": [
		84125,
		9,
		4125
	],
	"./collections/en/brands/ela/content": [
		29033,
		9,
		9033
	],
	"./collections/en/brands/ela/content.tsx": [
		29033,
		9,
		9033
	],
	"./collections/en/brands/elate-beauty/content": [
		20626,
		9,
		626
	],
	"./collections/en/brands/elate-beauty/content.tsx": [
		20626,
		9,
		626
	],
	"./collections/en/brands/everist/content": [
		43261,
		9,
		3261
	],
	"./collections/en/brands/everist/content.tsx": [
		43261,
		9,
		3261
	],
	"./collections/en/brands/everlasting-wardrobe/content": [
		88084,
		9,
		8084
	],
	"./collections/en/brands/everlasting-wardrobe/content.tsx": [
		88084,
		9,
		8084
	],
	"./collections/en/brands/fable/content": [
		91722,
		9,
		1722
	],
	"./collections/en/brands/fable/content.tsx": [
		91722,
		9,
		1722
	],
	"./collections/en/brands/frank-and-oak/content": [
		10292,
		9,
		292
	],
	"./collections/en/brands/frank-and-oak/content.tsx": [
		10292,
		9,
		292
	],
	"./collections/en/brands/genusee/content": [
		72096,
		9,
		2096
	],
	"./collections/en/brands/genusee/content.tsx": [
		72096,
		9,
		2096
	],
	"./collections/en/brands/goldilocks-goods/content": [
		7148,
		9,
		7148
	],
	"./collections/en/brands/goldilocks-goods/content.tsx": [
		7148,
		9,
		7148
	],
	"./collections/en/brands/greenhouse-juice/content": [
		75916,
		9,
		5916
	],
	"./collections/en/brands/greenhouse-juice/content.tsx": [
		75916,
		9,
		5916
	],
	"./collections/en/brands/guests-on-earth/content": [
		12264,
		9,
		2264
	],
	"./collections/en/brands/guests-on-earth/content.tsx": [
		12264,
		9,
		2264
	],
	"./collections/en/brands/happy-earth/content": [
		4593,
		9,
		4593
	],
	"./collections/en/brands/happy-earth/content.tsx": [
		4593,
		9,
		4593
	],
	"./collections/en/brands/hitch/content": [
		41897,
		9,
		1897
	],
	"./collections/en/brands/hitch/content.tsx": [
		41897,
		9,
		1897
	],
	"./collections/en/brands/iwi/content": [
		44953,
		9,
		4953
	],
	"./collections/en/brands/iwi/content.tsx": [
		44953,
		9,
		4953
	],
	"./collections/en/brands/knickey/content": [
		53835,
		9,
		3835
	],
	"./collections/en/brands/knickey/content.tsx": [
		53835,
		9,
		3835
	],
	"./collections/en/brands/kotn/content": [
		27836,
		9,
		7836
	],
	"./collections/en/brands/kotn/content.tsx": [
		27836,
		9,
		7836
	],
	"./collections/en/brands/leze-the-label/content": [
		11766,
		9,
		1766
	],
	"./collections/en/brands/leze-the-label/content.tsx": [
		11766,
		9,
		1766
	],
	"./collections/en/brands/linne-botanicals/content": [
		23195,
		9,
		3195
	],
	"./collections/en/brands/linne-botanicals/content.tsx": [
		23195,
		9,
		3195
	],
	"./collections/en/brands/ll-supply/content": [
		18929,
		9,
		8929
	],
	"./collections/en/brands/ll-supply/content.tsx": [
		18929,
		9,
		8929
	],
	"./collections/en/brands/lomi/content": [
		74619,
		9,
		4619
	],
	"./collections/en/brands/lomi/content.tsx": [
		74619,
		9,
		4619
	],
	"./collections/en/brands/londre/content": [
		73811,
		9,
		3811
	],
	"./collections/en/brands/londre/content.tsx": [
		73811,
		9,
		3811
	],
	"./collections/en/brands/look-organics/content": [
		3109,
		9,
		3109
	],
	"./collections/en/brands/look-organics/content.tsx": [
		3109,
		9,
		3109
	],
	"./collections/en/brands/mary-young/content": [
		72172,
		9,
		2172
	],
	"./collections/en/brands/mary-young/content.tsx": [
		72172,
		9,
		2172
	],
	"./collections/en/brands/mate-the-label/content": [
		15799,
		9,
		5799
	],
	"./collections/en/brands/mate-the-label/content.tsx": [
		15799,
		9,
		5799
	],
	"./collections/en/brands/meow-meow-tweet/content": [
		49367,
		9,
		9367
	],
	"./collections/en/brands/meow-meow-tweet/content.tsx": [
		49367,
		9,
		9367
	],
	"./collections/en/brands/miakoda/content": [
		92785,
		9,
		2785
	],
	"./collections/en/brands/miakoda/content.tsx": [
		92785,
		9,
		2785
	],
	"./collections/en/brands/mill/content": [
		58535,
		9,
		8535
	],
	"./collections/en/brands/mill/content.tsx": [
		58535,
		9,
		8535
	],
	"./collections/en/brands/mini-cycle/content": [
		42166,
		9,
		2166
	],
	"./collections/en/brands/mini-cycle/content.tsx": [
		42166,
		9,
		2166
	],
	"./collections/en/brands/mini-mioche/content": [
		54069,
		9,
		4069
	],
	"./collections/en/brands/mini-mioche/content.tsx": [
		54069,
		9,
		4069
	],
	"./collections/en/brands/monte-and-coe/content": [
		11730,
		9,
		1730
	],
	"./collections/en/brands/monte-and-coe/content.tsx": [
		11730,
		9,
		1730
	],
	"./collections/en/brands/nette-candles/content": [
		59016,
		9,
		9016
	],
	"./collections/en/brands/nette-candles/content.tsx": [
		59016,
		9,
		9016
	],
	"./collections/en/brands/nisolo/content": [
		19794,
		9,
		9794
	],
	"./collections/en/brands/nisolo/content.tsx": [
		19794,
		9,
		9794
	],
	"./collections/en/brands/nixit/content": [
		57166,
		9,
		7166
	],
	"./collections/en/brands/nixit/content.tsx": [
		57166,
		9,
		7166
	],
	"./collections/en/brands/norden/content": [
		41325,
		9,
		1325
	],
	"./collections/en/brands/norden/content.tsx": [
		41325,
		9,
		1325
	],
	"./collections/en/brands/open-farm/content": [
		37213,
		9,
		7213
	],
	"./collections/en/brands/open-farm/content.tsx": [
		37213,
		9,
		7213
	],
	"./collections/en/brands/package-free-shop/content": [
		58334,
		9,
		8334
	],
	"./collections/en/brands/package-free-shop/content.tsx": [
		58334,
		9,
		8334
	],
	"./collections/en/brands/patagonia/content": [
		65,
		9,
		65
	],
	"./collections/en/brands/patagonia/content.tsx": [
		65,
		9,
		65
	],
	"./collections/en/brands/pela/content": [
		85968,
		9,
		5968
	],
	"./collections/en/brands/pela/content.tsx": [
		85968,
		9,
		5968
	],
	"./collections/en/brands/petaluma/content": [
		1960,
		9,
		1960
	],
	"./collections/en/brands/petaluma/content.tsx": [
		1960,
		9,
		1960
	],
	"./collections/en/brands/plastno/content": [
		93386,
		9,
		3386
	],
	"./collections/en/brands/plastno/content.tsx": [
		93386,
		9,
		3386
	],
	"./collections/en/brands/prima/content": [
		90547,
		9,
		7453
	],
	"./collections/en/brands/prima/content.tsx": [
		90547,
		9,
		7453
	],
	"./collections/en/brands/propeller-coffee/content": [
		47871,
		9,
		7871
	],
	"./collections/en/brands/propeller-coffee/content.tsx": [
		47871,
		9,
		7871
	],
	"./collections/en/brands/province-apothecary/content": [
		65408,
		9,
		5408
	],
	"./collections/en/brands/province-apothecary/content.tsx": [
		65408,
		9,
		5408
	],
	"./collections/en/brands/rad-power-bikes/content": [
		88376,
		9,
		8376
	],
	"./collections/en/brands/rad-power-bikes/content.tsx": [
		88376,
		9,
		8376
	],
	"./collections/en/brands/ring-bear/content": [
		34056,
		9,
		4056
	],
	"./collections/en/brands/ring-bear/content.tsx": [
		34056,
		9,
		4056
	],
	"./collections/en/brands/rumpl/content": [
		32112,
		9,
		2112
	],
	"./collections/en/brands/rumpl/content.tsx": [
		32112,
		9,
		2112
	],
	"./collections/en/brands/saalt/content": [
		7912,
		9,
		7912
	],
	"./collections/en/brands/saalt/content.tsx": [
		7912,
		9,
		7912
	],
	"./collections/en/brands/saie/content": [
		24759,
		9,
		4759
	],
	"./collections/en/brands/saie/content.tsx": [
		24759,
		9,
		4759
	],
	"./collections/en/brands/saltwater-collective/content": [
		13511,
		9,
		3511
	],
	"./collections/en/brands/saltwater-collective/content.tsx": [
		13511,
		9,
		3511
	],
	"./collections/en/brands/samara/content": [
		22325,
		9,
		2325
	],
	"./collections/en/brands/samara/content.tsx": [
		22325,
		9,
		2325
	],
	"./collections/en/brands/scoria/content": [
		16728,
		9,
		6728
	],
	"./collections/en/brands/scoria/content.tsx": [
		16728,
		9,
		6728
	],
	"./collections/en/brands/suga-mat/content": [
		10353,
		9,
		353
	],
	"./collections/en/brands/suga-mat/content.tsx": [
		10353,
		9,
		353
	],
	"./collections/en/brands/sweetgreen-market/content": [
		42075,
		9,
		2075
	],
	"./collections/en/brands/sweetgreen-market/content.tsx": [
		42075,
		9,
		2075
	],
	"./collections/en/brands/tamga-designs/content": [
		4191,
		9,
		4191
	],
	"./collections/en/brands/tamga-designs/content.tsx": [
		4191,
		9,
		4191
	],
	"./collections/en/brands/tanit/content": [
		22978,
		9,
		2978
	],
	"./collections/en/brands/tanit/content.tsx": [
		22978,
		9,
		2978
	],
	"./collections/en/brands/tentree/content": [
		60420,
		9,
		420
	],
	"./collections/en/brands/tentree/content.tsx": [
		60420,
		9,
		420
	],
	"./collections/en/brands/the-bare-home/content": [
		61794,
		9,
		1794
	],
	"./collections/en/brands/the-bare-home/content.tsx": [
		61794,
		9,
		1794
	],
	"./collections/en/brands/the-big-carrot/content": [
		87404,
		9,
		7404
	],
	"./collections/en/brands/the-big-carrot/content.tsx": [
		87404,
		9,
		7404
	],
	"./collections/en/brands/the-market-bags/content": [
		79210,
		9,
		9210
	],
	"./collections/en/brands/the-market-bags/content.tsx": [
		79210,
		9,
		9210
	],
	"./collections/en/brands/therealreal/content": [
		26101,
		9,
		6101
	],
	"./collections/en/brands/therealreal/content.tsx": [
		26101,
		9,
		6101
	],
	"./collections/en/brands/thousand-fell/content": [
		242,
		9,
		242
	],
	"./collections/en/brands/thousand-fell/content.tsx": [
		242,
		9,
		242
	],
	"./collections/en/brands/thredup/content": [
		78758,
		9,
		8758
	],
	"./collections/en/brands/thredup/content.tsx": [
		78758,
		9,
		8758
	],
	"./collections/en/brands/thriftbooks/content": [
		8662,
		9,
		8662
	],
	"./collections/en/brands/thriftbooks/content.tsx": [
		8662,
		9,
		8662
	],
	"./collections/en/brands/triarchy/content": [
		33428,
		9,
		3428
	],
	"./collections/en/brands/triarchy/content.tsx": [
		33428,
		9,
		3428
	],
	"./collections/en/brands/tushy/content": [
		56630,
		9,
		6630
	],
	"./collections/en/brands/tushy/content.tsx": [
		56630,
		9,
		6630
	],
	"./collections/en/brands/uncle-studios/content": [
		94651,
		9,
		4651
	],
	"./collections/en/brands/uncle-studios/content.tsx": [
		94651,
		9,
		4651
	],
	"./collections/en/brands/upchoose/content": [
		31747,
		9,
		1747
	],
	"./collections/en/brands/upchoose/content.tsx": [
		31747,
		9,
		1747
	],
	"./collections/en/brands/ursa-major/content": [
		31464,
		9,
		1464
	],
	"./collections/en/brands/ursa-major/content.tsx": [
		31464,
		9,
		1464
	],
	"./collections/en/brands/village-juicery/content": [
		39603,
		9,
		9603
	],
	"./collections/en/brands/village-juicery/content.tsx": [
		39603,
		9,
		9603
	],
	"./collections/en/brands/wash-with-water/content": [
		91252,
		9,
		1252
	],
	"./collections/en/brands/wash-with-water/content.tsx": [
		91252,
		9,
		1252
	],
	"./collections/en/brands/whimsy-plus-row/content": [
		81152,
		9,
		1152
	],
	"./collections/en/brands/whimsy-plus-row/content.tsx": [
		81152,
		9,
		1152
	],
	"./collections/en/brands/who-gives-a-crap/content": [
		51569,
		9,
		1569
	],
	"./collections/en/brands/who-gives-a-crap/content.tsx": [
		51569,
		9,
		1569
	],
	"./collections/en/customer-stories": [
		21839,
		9,
		1839
	],
	"./collections/en/customer-stories/": [
		21839,
		9,
		1839
	],
	"./collections/en/customer-stories/index": [
		21839,
		9,
		1839
	],
	"./collections/en/customer-stories/index.ts": [
		21839,
		9,
		1839
	],
	"./collections/en/customer-stories/powershifter/content": [
		49121,
		9,
		9121
	],
	"./collections/en/customer-stories/powershifter/content.tsx": [
		49121,
		9,
		9121
	],
	"./collections/en/customer-stories/redbrick/content": [
		77394,
		9,
		7394
	],
	"./collections/en/customer-stories/redbrick/content.tsx": [
		77394,
		9,
		7394
	],
	"./collections/en/customers": [
		43709,
		9,
		3709
	],
	"./collections/en/customers/": [
		43709,
		9,
		3709
	],
	"./collections/en/customers/index": [
		43709,
		9,
		3709
	],
	"./collections/en/customers/index.ts": [
		43709,
		9,
		3709
	],
	"./collections/en/customers/manifest-climate/content": [
		31163,
		9,
		1163
	],
	"./collections/en/customers/manifest-climate/content.ts": [
		31163,
		9,
		1163
	],
	"./collections/en/customers/manulife/content": [
		41423,
		9,
		1423
	],
	"./collections/en/customers/manulife/content.ts": [
		41423,
		9,
		1423
	],
	"./collections/en/customers/powershifter/content": [
		72196,
		9,
		2196
	],
	"./collections/en/customers/powershifter/content.ts": [
		72196,
		9,
		2196
	],
	"./collections/en/customers/redbrick/content": [
		82069,
		9,
		2069
	],
	"./collections/en/customers/redbrick/content.ts": [
		82069,
		9,
		2069
	],
	"./collections/en/customers/sherpa/content": [
		79155,
		9,
		9155
	],
	"./collections/en/customers/sherpa/content.ts": [
		79155,
		9,
		9155
	],
	"./collections/en/points/calculate-quarterly/content": [
		14817,
		9,
		4817
	],
	"./collections/en/points/calculate-quarterly/content.tsx": [
		14817,
		9,
		4817
	],
	"./collections/en/points/carbon-removal-redemption/content": [
		98153,
		9,
		8153
	],
	"./collections/en/points/carbon-removal-redemption/content.tsx": [
		98153,
		9,
		8153
	],
	"./collections/en/points/challenge-completion/content": [
		20029,
		9,
		29
	],
	"./collections/en/points/challenge-completion/content.tsx": [
		20029,
		9,
		29
	],
	"./collections/en/points/challenge-step-completion/content": [
		10399,
		9,
		399
	],
	"./collections/en/points/challenge-step-completion/content.tsx": [
		10399,
		9,
		399
	],
	"./collections/en/points/chat-app-click/content": [
		35658,
		9,
		5658
	],
	"./collections/en/points/chat-app-click/content.tsx": [
		35658,
		9,
		5658
	],
	"./collections/en/points/feedback-submission/content": [
		20638,
		9,
		638
	],
	"./collections/en/points/feedback-submission/content.tsx": [
		20638,
		9,
		638
	],
	"./collections/en/points/gift-card-redemption/content": [
		54872,
		9,
		4872
	],
	"./collections/en/points/gift-card-redemption/content.tsx": [
		54872,
		9,
		4872
	],
	"./collections/en/points/recalculate-personal/content": [
		29387,
		9,
		9387
	],
	"./collections/en/points/recalculate-personal/content.tsx": [
		29387,
		9,
		9387
	],
	"./collections/en/points/signup/content": [
		50832,
		9,
		832
	],
	"./collections/en/points/signup/content.tsx": [
		50832,
		9,
		832
	],
	"./collections/en/points/site-feedback-submission/content": [
		31551,
		9,
		1551
	],
	"./collections/en/points/site-feedback-submission/content.tsx": [
		31551,
		9,
		1551
	],
	"./collections/en/points/top-of-leaderboard/content": [
		52212,
		9,
		2212
	],
	"./collections/en/points/top-of-leaderboard/content.tsx": [
		52212,
		9,
		2212
	],
	"./collections/en/points/use-discount-code/content": [
		5106,
		9,
		5106
	],
	"./collections/en/points/use-discount-code/content.tsx": [
		5106,
		9,
		5106
	],
	"./collections/en/points/user-referral/content": [
		71650,
		9,
		1650
	],
	"./collections/en/points/user-referral/content.tsx": [
		71650,
		9,
		1650
	],
	"./collections/en/projects": [
		93894,
		9,
		3894
	],
	"./collections/en/projects/": [
		93894,
		9,
		3894
	],
	"./collections/en/projects/carbon-cure-concrete/content": [
		21537,
		9,
		1537
	],
	"./collections/en/projects/carbon-cure-concrete/content.tsx": [
		21537,
		9,
		1537
	],
	"./collections/en/projects/chinchina-reforestation/content": [
		97787,
		9,
		7787
	],
	"./collections/en/projects/chinchina-reforestation/content.tsx": [
		97787,
		9,
		7787
	],
	"./collections/en/projects/crow-lake-wind-power/content": [
		71088,
		9,
		1088
	],
	"./collections/en/projects/crow-lake-wind-power/content.tsx": [
		71088,
		9,
		1088
	],
	"./collections/en/projects/envira-amazonia-forest-protection/content": [
		98966,
		9,
		8966
	],
	"./collections/en/projects/envira-amazonia-forest-protection/content.tsx": [
		98966,
		9,
		8966
	],
	"./collections/en/projects/greentrees-reforestation/content": [
		56428,
		9,
		6189
	],
	"./collections/en/projects/greentrees-reforestation/content.tsx": [
		56428,
		9,
		6189
	],
	"./collections/en/projects/gujarat-state-wind-power/content": [
		12045,
		9,
		2045
	],
	"./collections/en/projects/gujarat-state-wind-power/content.tsx": [
		12045,
		9,
		2045
	],
	"./collections/en/projects/hebei-province-wind-power/content": [
		29611,
		9,
		9611
	],
	"./collections/en/projects/hebei-province-wind-power/content.tsx": [
		29611,
		9,
		9611
	],
	"./collections/en/projects/high-efficiency-cookstoves/content": [
		29194,
		9,
		9194
	],
	"./collections/en/projects/high-efficiency-cookstoves/content.tsx": [
		29194,
		9,
		9194
	],
	"./collections/en/projects/index": [
		93894,
		9,
		3894
	],
	"./collections/en/projects/index.ts": [
		93894,
		9,
		3894
	],
	"./collections/en/projects/katingan-redd-forest-protection/content": [
		42718,
		9,
		2718
	],
	"./collections/en/projects/katingan-redd-forest-protection/content.tsx": [
		42718,
		9,
		2718
	],
	"./collections/en/projects/kelp-forests/content": [
		70300,
		9,
		300
	],
	"./collections/en/projects/kelp-forests/content.tsx": [
		70300,
		9,
		300
	],
	"./collections/en/projects/methane-capture/content": [
		19185,
		9,
		9185
	],
	"./collections/en/projects/methane-capture/content.tsx": [
		19185,
		9,
		9185
	],
	"./collections/en/projects/minnesota-foam-substitution/content": [
		20200,
		9,
		200
	],
	"./collections/en/projects/minnesota-foam-substitution/content.tsx": [
		20200,
		9,
		200
	],
	"./collections/en/projects/mongolia-forest-conservation/content": [
		50565,
		9,
		565
	],
	"./collections/en/projects/mongolia-forest-conservation/content.tsx": [
		50565,
		9,
		565
	],
	"./collections/en/projects/siam-solar-power/content": [
		78089,
		9,
		8089
	],
	"./collections/en/projects/siam-solar-power/content.tsx": [
		78089,
		9,
		8089
	],
	"./collections/en/projects/tradewater-us-refrigerant-destruction/content": [
		39432,
		9,
		9432
	],
	"./collections/en/projects/tradewater-us-refrigerant-destruction/content.tsx": [
		39432,
		9,
		9432
	],
	"./collections/en/projects/water-filter-distribution/content": [
		54195,
		9,
		4195
	],
	"./collections/en/projects/water-filter-distribution/content.tsx": [
		54195,
		9,
		4195
	],
	"./collections/fr/brands/alter-eco/content": [
		65186,
		9,
		5186
	],
	"./collections/fr/brands/alter-eco/content.tsx": [
		65186,
		9,
		5186
	],
	"./collections/fr/brands/anian/content": [
		68699,
		9,
		8699
	],
	"./collections/fr/brands/anian/content.tsx": [
		68699,
		9,
		8699
	],
	"./collections/fr/brands/avocado-green-brands/content": [
		46325,
		9,
		6325
	],
	"./collections/fr/brands/avocado-green-brands/content.tsx": [
		46325,
		9,
		6325
	],
	"./collections/fr/brands/bather/content": [
		21894,
		9,
		1894
	],
	"./collections/fr/brands/bather/content.tsx": [
		21894,
		9,
		1894
	],
	"./collections/fr/brands/bee-keepers-naturals/content": [
		45459,
		9,
		5459
	],
	"./collections/fr/brands/bee-keepers-naturals/content.tsx": [
		45459,
		9,
		5459
	],
	"./collections/fr/brands/better-basics/content": [
		54943,
		9,
		4943
	],
	"./collections/fr/brands/better-basics/content.tsx": [
		54943,
		9,
		4943
	],
	"./collections/fr/brands/bio-raw/content": [
		92798,
		9,
		2798
	],
	"./collections/fr/brands/bio-raw/content.tsx": [
		92798,
		9,
		2798
	],
	"./collections/fr/brands/bloedstone/content": [
		14502,
		9,
		4502
	],
	"./collections/fr/brands/bloedstone/content.tsx": [
		14502,
		9,
		4502
	],
	"./collections/fr/brands/blueland/content": [
		43034,
		9,
		3034
	],
	"./collections/fr/brands/blueland/content.tsx": [
		43034,
		9,
		3034
	],
	"./collections/fr/brands/bondi-born/content": [
		5418,
		9,
		5418
	],
	"./collections/fr/brands/bondi-born/content.tsx": [
		5418,
		9,
		5418
	],
	"./collections/fr/brands/boyish/content": [
		88676,
		9,
		8676
	],
	"./collections/fr/brands/boyish/content.tsx": [
		88676,
		9,
		8676
	],
	"./collections/fr/brands/byo-long-beach/content": [
		45995,
		9,
		5995
	],
	"./collections/fr/brands/byo-long-beach/content.tsx": [
		45995,
		9,
		5995
	],
	"./collections/fr/brands/chopvalue/content": [
		26227,
		9,
		6227
	],
	"./collections/fr/brands/chopvalue/content.tsx": [
		26227,
		9,
		6227
	],
	"./collections/fr/brands/culthread/content": [
		26958,
		9,
		6958
	],
	"./collections/fr/brands/culthread/content.tsx": [
		26958,
		9,
		6958
	],
	"./collections/fr/brands/dear-survivor/content": [
		92533,
		9,
		2533
	],
	"./collections/fr/brands/dear-survivor/content.tsx": [
		92533,
		9,
		2533
	],
	"./collections/fr/brands/eclipse-coffee-roasters/content": [
		52307,
		9,
		2307
	],
	"./collections/fr/brands/eclipse-coffee-roasters/content.tsx": [
		52307,
		9,
		2307
	],
	"./collections/fr/brands/ecologyst/content": [
		92083,
		9,
		2083
	],
	"./collections/fr/brands/ecologyst/content.tsx": [
		92083,
		9,
		2083
	],
	"./collections/fr/brands/ela/content": [
		39904,
		9,
		9904
	],
	"./collections/fr/brands/ela/content.tsx": [
		39904,
		9,
		9904
	],
	"./collections/fr/brands/elate-beauty/content": [
		97301,
		9,
		7301
	],
	"./collections/fr/brands/elate-beauty/content.tsx": [
		97301,
		9,
		7301
	],
	"./collections/fr/brands/everist/content": [
		63087,
		9,
		3087
	],
	"./collections/fr/brands/everist/content.tsx": [
		63087,
		9,
		3087
	],
	"./collections/fr/brands/everlasting-wardrobe/content": [
		24370,
		9,
		4370
	],
	"./collections/fr/brands/everlasting-wardrobe/content.tsx": [
		24370,
		9,
		4370
	],
	"./collections/fr/brands/fable/content": [
		83250,
		9,
		3250
	],
	"./collections/fr/brands/fable/content.tsx": [
		83250,
		9,
		3250
	],
	"./collections/fr/brands/frank-and-oak/content": [
		73323,
		9,
		3323
	],
	"./collections/fr/brands/frank-and-oak/content.tsx": [
		73323,
		9,
		3323
	],
	"./collections/fr/brands/genusee/content": [
		63333,
		9,
		3333
	],
	"./collections/fr/brands/genusee/content.tsx": [
		63333,
		9,
		3333
	],
	"./collections/fr/brands/goldilocks-goods/content": [
		41557,
		9,
		1557
	],
	"./collections/fr/brands/goldilocks-goods/content.tsx": [
		41557,
		9,
		1557
	],
	"./collections/fr/brands/greenhouse-juice/content": [
		73613,
		9,
		3613
	],
	"./collections/fr/brands/greenhouse-juice/content.tsx": [
		73613,
		9,
		3613
	],
	"./collections/fr/brands/guests-on-earth/content": [
		91832,
		9,
		1832
	],
	"./collections/fr/brands/guests-on-earth/content.tsx": [
		91832,
		9,
		1832
	],
	"./collections/fr/brands/happy-earth/content": [
		90441,
		9,
		441
	],
	"./collections/fr/brands/happy-earth/content.tsx": [
		90441,
		9,
		441
	],
	"./collections/fr/brands/hitch/content": [
		24499,
		9,
		4499
	],
	"./collections/fr/brands/hitch/content.tsx": [
		24499,
		9,
		4499
	],
	"./collections/fr/brands/iwi/content": [
		28917,
		9,
		8917
	],
	"./collections/fr/brands/iwi/content.tsx": [
		28917,
		9,
		8917
	],
	"./collections/fr/brands/knickey/content": [
		31162,
		9,
		1162
	],
	"./collections/fr/brands/knickey/content.tsx": [
		31162,
		9,
		1162
	],
	"./collections/fr/brands/kotn/content": [
		48577,
		9,
		8577
	],
	"./collections/fr/brands/kotn/content.tsx": [
		48577,
		9,
		8577
	],
	"./collections/fr/brands/leze-the-label/content": [
		1510,
		9,
		1510
	],
	"./collections/fr/brands/leze-the-label/content.tsx": [
		1510,
		9,
		1510
	],
	"./collections/fr/brands/linne-botanicals/content": [
		80399,
		9,
		878
	],
	"./collections/fr/brands/linne-botanicals/content.tsx": [
		80399,
		9,
		878
	],
	"./collections/fr/brands/ll-supply/content": [
		19143,
		9,
		9143
	],
	"./collections/fr/brands/ll-supply/content.tsx": [
		19143,
		9,
		9143
	],
	"./collections/fr/brands/lomi/content": [
		71965,
		9,
		1965
	],
	"./collections/fr/brands/lomi/content.tsx": [
		71965,
		9,
		1965
	],
	"./collections/fr/brands/londre/content": [
		56156,
		9,
		6156
	],
	"./collections/fr/brands/londre/content.tsx": [
		56156,
		9,
		6156
	],
	"./collections/fr/brands/look-organics/content": [
		27429,
		9,
		7429
	],
	"./collections/fr/brands/look-organics/content.tsx": [
		27429,
		9,
		7429
	],
	"./collections/fr/brands/mary-young/content": [
		52628,
		9,
		2628
	],
	"./collections/fr/brands/mary-young/content.tsx": [
		52628,
		9,
		2628
	],
	"./collections/fr/brands/mate-the-label/content": [
		70614,
		9,
		614
	],
	"./collections/fr/brands/mate-the-label/content.tsx": [
		70614,
		9,
		614
	],
	"./collections/fr/brands/meow-meow-tweet/content": [
		75921,
		9,
		5921
	],
	"./collections/fr/brands/meow-meow-tweet/content.tsx": [
		75921,
		9,
		5921
	],
	"./collections/fr/brands/miakoda/content": [
		75854,
		9,
		5854
	],
	"./collections/fr/brands/miakoda/content.tsx": [
		75854,
		9,
		5854
	],
	"./collections/fr/brands/mill/content": [
		60571,
		9,
		571
	],
	"./collections/fr/brands/mill/content.tsx": [
		60571,
		9,
		571
	],
	"./collections/fr/brands/mini-cycle/content": [
		38541,
		9,
		8541
	],
	"./collections/fr/brands/mini-cycle/content.tsx": [
		38541,
		9,
		8541
	],
	"./collections/fr/brands/mini-mioche/content": [
		45005,
		9,
		5005
	],
	"./collections/fr/brands/mini-mioche/content.tsx": [
		45005,
		9,
		5005
	],
	"./collections/fr/brands/monte-and-coe/content": [
		79680,
		9,
		9680
	],
	"./collections/fr/brands/monte-and-coe/content.tsx": [
		79680,
		9,
		9680
	],
	"./collections/fr/brands/nette-candles/content": [
		11736,
		9,
		1736
	],
	"./collections/fr/brands/nette-candles/content.tsx": [
		11736,
		9,
		1736
	],
	"./collections/fr/brands/nisolo/content": [
		63790,
		9,
		3790
	],
	"./collections/fr/brands/nisolo/content.tsx": [
		63790,
		9,
		3790
	],
	"./collections/fr/brands/nixit/content": [
		89574,
		9,
		9574
	],
	"./collections/fr/brands/nixit/content.tsx": [
		89574,
		9,
		9574
	],
	"./collections/fr/brands/norden/content": [
		23818,
		9,
		3818
	],
	"./collections/fr/brands/norden/content.tsx": [
		23818,
		9,
		3818
	],
	"./collections/fr/brands/open-farm/content": [
		65530,
		9,
		5530
	],
	"./collections/fr/brands/open-farm/content.tsx": [
		65530,
		9,
		5530
	],
	"./collections/fr/brands/package-free-shop/content": [
		14850,
		9,
		4850
	],
	"./collections/fr/brands/package-free-shop/content.tsx": [
		14850,
		9,
		4850
	],
	"./collections/fr/brands/patagonia/content": [
		42095,
		9,
		2095
	],
	"./collections/fr/brands/patagonia/content.tsx": [
		42095,
		9,
		2095
	],
	"./collections/fr/brands/pela/content": [
		70640,
		9,
		640
	],
	"./collections/fr/brands/pela/content.tsx": [
		70640,
		9,
		640
	],
	"./collections/fr/brands/petaluma/content": [
		41936,
		9,
		1936
	],
	"./collections/fr/brands/petaluma/content.tsx": [
		41936,
		9,
		1936
	],
	"./collections/fr/brands/plastno/content": [
		16428,
		9,
		6428
	],
	"./collections/fr/brands/plastno/content.tsx": [
		16428,
		9,
		6428
	],
	"./collections/fr/brands/prima/content": [
		6316,
		9,
		6316
	],
	"./collections/fr/brands/prima/content.tsx": [
		6316,
		9,
		6316
	],
	"./collections/fr/brands/propeller-coffee/content": [
		62399,
		9,
		2399
	],
	"./collections/fr/brands/propeller-coffee/content.tsx": [
		62399,
		9,
		2399
	],
	"./collections/fr/brands/province-apothecary/content": [
		41523,
		9,
		1523
	],
	"./collections/fr/brands/province-apothecary/content.tsx": [
		41523,
		9,
		1523
	],
	"./collections/fr/brands/rad-power-bikes/content": [
		28356,
		9,
		8356
	],
	"./collections/fr/brands/rad-power-bikes/content.tsx": [
		28356,
		9,
		8356
	],
	"./collections/fr/brands/ring-bear/content": [
		14369,
		9,
		4369
	],
	"./collections/fr/brands/ring-bear/content.tsx": [
		14369,
		9,
		4369
	],
	"./collections/fr/brands/rumpl/content": [
		25418,
		9,
		6154
	],
	"./collections/fr/brands/rumpl/content.tsx": [
		25418,
		9,
		6154
	],
	"./collections/fr/brands/saalt/content": [
		50895,
		9,
		895
	],
	"./collections/fr/brands/saalt/content.tsx": [
		50895,
		9,
		895
	],
	"./collections/fr/brands/saie/content": [
		54669,
		9,
		4669
	],
	"./collections/fr/brands/saie/content.tsx": [
		54669,
		9,
		4669
	],
	"./collections/fr/brands/saltwater-collective/content": [
		3527,
		9,
		3527
	],
	"./collections/fr/brands/saltwater-collective/content.tsx": [
		3527,
		9,
		3527
	],
	"./collections/fr/brands/samara/content": [
		56496,
		9,
		6496
	],
	"./collections/fr/brands/samara/content.tsx": [
		56496,
		9,
		6496
	],
	"./collections/fr/brands/scoria/content": [
		81703,
		9,
		1703
	],
	"./collections/fr/brands/scoria/content.tsx": [
		81703,
		9,
		1703
	],
	"./collections/fr/brands/suga-mat/content": [
		73496,
		9,
		8129
	],
	"./collections/fr/brands/suga-mat/content.tsx": [
		73496,
		9,
		8129
	],
	"./collections/fr/brands/sweetgreen-market/content": [
		29434,
		9,
		9434
	],
	"./collections/fr/brands/sweetgreen-market/content.tsx": [
		29434,
		9,
		9434
	],
	"./collections/fr/brands/tamga-designs/content": [
		26625,
		9,
		6625
	],
	"./collections/fr/brands/tamga-designs/content.tsx": [
		26625,
		9,
		6625
	],
	"./collections/fr/brands/tanit/content": [
		69244,
		9,
		9244
	],
	"./collections/fr/brands/tanit/content.tsx": [
		69244,
		9,
		9244
	],
	"./collections/fr/brands/tentree/content": [
		92013,
		9,
		2013
	],
	"./collections/fr/brands/tentree/content.tsx": [
		92013,
		9,
		2013
	],
	"./collections/fr/brands/the-bare-home/content": [
		95466,
		9,
		5466
	],
	"./collections/fr/brands/the-bare-home/content.tsx": [
		95466,
		9,
		5466
	],
	"./collections/fr/brands/the-big-carrot/content": [
		92707,
		9,
		2707
	],
	"./collections/fr/brands/the-big-carrot/content.tsx": [
		92707,
		9,
		2707
	],
	"./collections/fr/brands/the-market-bags/content": [
		41819,
		9,
		1819
	],
	"./collections/fr/brands/the-market-bags/content.tsx": [
		41819,
		9,
		1819
	],
	"./collections/fr/brands/therealreal/content": [
		70443,
		9,
		443
	],
	"./collections/fr/brands/therealreal/content.tsx": [
		70443,
		9,
		443
	],
	"./collections/fr/brands/thousand-fell/content": [
		52478,
		9,
		2478
	],
	"./collections/fr/brands/thousand-fell/content.tsx": [
		52478,
		9,
		2478
	],
	"./collections/fr/brands/thredup/content": [
		20388,
		9,
		388
	],
	"./collections/fr/brands/thredup/content.tsx": [
		20388,
		9,
		388
	],
	"./collections/fr/brands/thriftbooks/content": [
		56825,
		9,
		6825
	],
	"./collections/fr/brands/thriftbooks/content.tsx": [
		56825,
		9,
		6825
	],
	"./collections/fr/brands/triarchy/content": [
		26901,
		9,
		6901
	],
	"./collections/fr/brands/triarchy/content.tsx": [
		26901,
		9,
		6901
	],
	"./collections/fr/brands/tushy/content": [
		61256,
		9,
		1256
	],
	"./collections/fr/brands/tushy/content.tsx": [
		61256,
		9,
		1256
	],
	"./collections/fr/brands/uncle-studios/content": [
		17968,
		9,
		7968
	],
	"./collections/fr/brands/uncle-studios/content.tsx": [
		17968,
		9,
		7968
	],
	"./collections/fr/brands/upchoose/content": [
		64484,
		9,
		4484
	],
	"./collections/fr/brands/upchoose/content.tsx": [
		64484,
		9,
		4484
	],
	"./collections/fr/brands/ursa-major/content": [
		88075,
		9,
		8075
	],
	"./collections/fr/brands/ursa-major/content.tsx": [
		88075,
		9,
		8075
	],
	"./collections/fr/brands/village-juicery/content": [
		84194,
		9,
		4194
	],
	"./collections/fr/brands/village-juicery/content.tsx": [
		84194,
		9,
		4194
	],
	"./collections/fr/brands/wash-with-water/content": [
		75928,
		9,
		5928
	],
	"./collections/fr/brands/wash-with-water/content.tsx": [
		75928,
		9,
		5928
	],
	"./collections/fr/brands/whimsy-plus-row/content": [
		60582,
		9,
		582
	],
	"./collections/fr/brands/whimsy-plus-row/content.tsx": [
		60582,
		9,
		582
	],
	"./collections/fr/brands/who-gives-a-crap/content": [
		83665,
		9,
		3665
	],
	"./collections/fr/brands/who-gives-a-crap/content.tsx": [
		83665,
		9,
		3665
	],
	"./collections/fr/customer-stories": [
		86007,
		9,
		6007
	],
	"./collections/fr/customer-stories/": [
		86007,
		9,
		6007
	],
	"./collections/fr/customer-stories/index": [
		86007,
		9,
		6007
	],
	"./collections/fr/customer-stories/index.ts": [
		86007,
		9,
		6007
	],
	"./collections/fr/customer-stories/powershifter/content": [
		19749,
		9,
		9749
	],
	"./collections/fr/customer-stories/powershifter/content.tsx": [
		19749,
		9,
		9749
	],
	"./collections/fr/customer-stories/redbrick/content": [
		42861,
		9,
		2861
	],
	"./collections/fr/customer-stories/redbrick/content.tsx": [
		42861,
		9,
		2861
	],
	"./collections/fr/points/calculate-quarterly/content": [
		6379,
		9,
		6379
	],
	"./collections/fr/points/calculate-quarterly/content.tsx": [
		6379,
		9,
		6379
	],
	"./collections/fr/points/carbon-removal-redemption/content": [
		90285,
		9,
		285
	],
	"./collections/fr/points/carbon-removal-redemption/content.tsx": [
		90285,
		9,
		285
	],
	"./collections/fr/points/challenge-completion/content": [
		18538,
		9,
		8538
	],
	"./collections/fr/points/challenge-completion/content.tsx": [
		18538,
		9,
		8538
	],
	"./collections/fr/points/challenge-step-completion/content": [
		53478,
		9,
		3478
	],
	"./collections/fr/points/challenge-step-completion/content.tsx": [
		53478,
		9,
		3478
	],
	"./collections/fr/points/chat-app-click/content": [
		78095,
		9,
		8095
	],
	"./collections/fr/points/chat-app-click/content.tsx": [
		78095,
		9,
		8095
	],
	"./collections/fr/points/feedback-submission/content": [
		68489,
		9,
		8489
	],
	"./collections/fr/points/feedback-submission/content.tsx": [
		68489,
		9,
		8489
	],
	"./collections/fr/points/gift-card-redemption/content": [
		99938,
		9,
		9938
	],
	"./collections/fr/points/gift-card-redemption/content.tsx": [
		99938,
		9,
		9938
	],
	"./collections/fr/points/recalculate-personal/content": [
		82079,
		9,
		2079
	],
	"./collections/fr/points/recalculate-personal/content.tsx": [
		82079,
		9,
		2079
	],
	"./collections/fr/points/signup/content": [
		81935,
		9,
		1935
	],
	"./collections/fr/points/signup/content.tsx": [
		81935,
		9,
		1935
	],
	"./collections/fr/points/site-feedback-submission/content": [
		17252,
		9,
		7252
	],
	"./collections/fr/points/site-feedback-submission/content.tsx": [
		17252,
		9,
		7252
	],
	"./collections/fr/points/top-of-leaderboard/content": [
		34016,
		9,
		4016
	],
	"./collections/fr/points/top-of-leaderboard/content.tsx": [
		34016,
		9,
		4016
	],
	"./collections/fr/points/use-discount-code/content": [
		83266,
		9,
		3266
	],
	"./collections/fr/points/use-discount-code/content.tsx": [
		83266,
		9,
		3266
	],
	"./collections/fr/points/user-referral/content": [
		84703,
		9,
		4703
	],
	"./collections/fr/points/user-referral/content.tsx": [
		84703,
		9,
		4703
	],
	"./collections/fr/projects": [
		81370,
		9,
		1370
	],
	"./collections/fr/projects/": [
		81370,
		9,
		1370
	],
	"./collections/fr/projects/carbon-cure-concrete/content": [
		53542,
		9,
		3542
	],
	"./collections/fr/projects/carbon-cure-concrete/content.tsx": [
		53542,
		9,
		3542
	],
	"./collections/fr/projects/chinchina-reforestation/content": [
		41847,
		9,
		6404
	],
	"./collections/fr/projects/chinchina-reforestation/content.tsx": [
		41847,
		9,
		6404
	],
	"./collections/fr/projects/crow-lake-wind-power/content": [
		13316,
		9,
		3316
	],
	"./collections/fr/projects/crow-lake-wind-power/content.tsx": [
		13316,
		9,
		3316
	],
	"./collections/fr/projects/envira-amazonia-forest-protection/content": [
		95655,
		9,
		5655
	],
	"./collections/fr/projects/envira-amazonia-forest-protection/content.tsx": [
		95655,
		9,
		5655
	],
	"./collections/fr/projects/greentrees-reforestation/content": [
		17768,
		9,
		7768
	],
	"./collections/fr/projects/greentrees-reforestation/content.tsx": [
		17768,
		9,
		7768
	],
	"./collections/fr/projects/gujarat-state-wind-power/content": [
		83146,
		9,
		3146
	],
	"./collections/fr/projects/gujarat-state-wind-power/content.tsx": [
		83146,
		9,
		3146
	],
	"./collections/fr/projects/hebei-province-wind-power/content": [
		6362,
		9,
		6362
	],
	"./collections/fr/projects/hebei-province-wind-power/content.tsx": [
		6362,
		9,
		6362
	],
	"./collections/fr/projects/high-efficiency-cookstoves/content": [
		42271,
		9,
		2271
	],
	"./collections/fr/projects/high-efficiency-cookstoves/content.tsx": [
		42271,
		9,
		2271
	],
	"./collections/fr/projects/index": [
		81370,
		9,
		1370
	],
	"./collections/fr/projects/index.ts": [
		81370,
		9,
		1370
	],
	"./collections/fr/projects/katingan-redd-forest-protection/content": [
		9175,
		9,
		9175
	],
	"./collections/fr/projects/katingan-redd-forest-protection/content.tsx": [
		9175,
		9,
		9175
	],
	"./collections/fr/projects/kelp-forests/content": [
		93709,
		9,
		378
	],
	"./collections/fr/projects/kelp-forests/content.tsx": [
		93709,
		9,
		378
	],
	"./collections/fr/projects/methane-capture/content": [
		3663,
		9,
		3663
	],
	"./collections/fr/projects/methane-capture/content.tsx": [
		3663,
		9,
		3663
	],
	"./collections/fr/projects/minnesota-foam-substitution/content": [
		43221,
		9,
		3221
	],
	"./collections/fr/projects/minnesota-foam-substitution/content.tsx": [
		43221,
		9,
		3221
	],
	"./collections/fr/projects/mongolia-forest-conservation/content": [
		94177,
		9,
		4177
	],
	"./collections/fr/projects/mongolia-forest-conservation/content.tsx": [
		94177,
		9,
		4177
	],
	"./collections/fr/projects/siam-solar-power/content": [
		23679,
		9,
		3679
	],
	"./collections/fr/projects/siam-solar-power/content.tsx": [
		23679,
		9,
		3679
	],
	"./collections/fr/projects/tradewater-us-refrigerant-destruction/content": [
		42737,
		9,
		2737
	],
	"./collections/fr/projects/tradewater-us-refrigerant-destruction/content.tsx": [
		42737,
		9,
		2737
	],
	"./collections/fr/projects/water-filter-distribution/content": [
		88024,
		9,
		8024
	],
	"./collections/fr/projects/water-filter-distribution/content.tsx": [
		88024,
		9,
		8024
	],
	"./collections/types": [
		69214,
		9,
		9214
	],
	"./collections/types.ts": [
		69214,
		9,
		9214
	],
	"./content.types": [
		45273,
		9,
		5273
	],
	"./content.types.ts": [
		45273,
		9,
		5273
	],
	"./global/en/banner/content": [
		62938,
		9,
		2938
	],
	"./global/en/banner/content.ts": [
		62938,
		9,
		2938
	],
	"./global/en/brand-card/content": [
		75810,
		9,
		5810
	],
	"./global/en/brand-card/content.tsx": [
		75810,
		9,
		5810
	],
	"./global/en/challenge/content": [
		25872,
		9,
		5872
	],
	"./global/en/challenge/content.ts": [
		25872,
		9,
		5872
	],
	"./global/en/content-settings/content": [
		53838,
		9,
		3838
	],
	"./global/en/content-settings/content.ts": [
		53838,
		9,
		3838
	],
	"./global/en/file-dropzone/content": [
		78793,
		9,
		8793
	],
	"./global/en/file-dropzone/content.ts": [
		78793,
		9,
		8793
	],
	"./global/en/filters/content": [
		42263,
		9,
		2263
	],
	"./global/en/filters/content.ts": [
		42263,
		9,
		2263
	],
	"./global/en/footer/content": [
		83733,
		9,
		3733
	],
	"./global/en/footer/content.tsx": [
		83733,
		9,
		3733
	],
	"./global/en/header/content": [
		60242,
		9,
		7711
	],
	"./global/en/header/content.ts": [
		60242,
		9,
		7711
	],
	"./global/en/invite-members/content": [
		58190,
		9,
		8190
	],
	"./global/en/invite-members/content.tsx": [
		58190,
		9,
		8190
	],
	"./global/en/module-example-popup/content": [
		48513,
		9,
		8513
	],
	"./global/en/module-example-popup/content.tsx": [
		48513,
		9,
		8513
	],
	"./global/en/module-item/content": [
		19158,
		9,
		9158
	],
	"./global/en/module-item/content.tsx": [
		19158,
		9,
		9158
	],
	"./global/en/pagination/content": [
		73426,
		9,
		3426
	],
	"./global/en/pagination/content.ts": [
		73426,
		9,
		3426
	],
	"./global/en/request-custom-module/content": [
		41356,
		9,
		1356
	],
	"./global/en/request-custom-module/content.tsx": [
		41356,
		9,
		1356
	],
	"./global/en/select/content": [
		16106,
		9,
		6106
	],
	"./global/en/select/content.ts": [
		16106,
		9,
		6106
	],
	"./global/fr/banner/content": [
		39326,
		9,
		9326
	],
	"./global/fr/banner/content.ts": [
		39326,
		9,
		9326
	],
	"./global/fr/challenge/content": [
		84924,
		9,
		4924
	],
	"./global/fr/challenge/content.ts": [
		84924,
		9,
		4924
	],
	"./global/fr/content-settings/content": [
		3314,
		9,
		3314
	],
	"./global/fr/content-settings/content.ts": [
		3314,
		9,
		3314
	],
	"./global/fr/file-dropzone/content": [
		54434,
		9,
		4434
	],
	"./global/fr/file-dropzone/content.ts": [
		54434,
		9,
		4434
	],
	"./global/fr/footer/content": [
		77181,
		9,
		8390
	],
	"./global/fr/footer/content.tsx": [
		77181,
		9,
		8390
	],
	"./global/fr/header/content": [
		77740,
		9,
		7740
	],
	"./global/fr/header/content.ts": [
		77740,
		9,
		7740
	],
	"./global/fr/invite-members/content": [
		48976,
		9,
		8976
	],
	"./global/fr/invite-members/content.tsx": [
		48976,
		9,
		8976
	],
	"./global/fr/module-example-popup/content": [
		48006,
		9,
		8006
	],
	"./global/fr/module-example-popup/content.tsx": [
		48006,
		9,
		8006
	],
	"./global/fr/pagination/content": [
		97158,
		9,
		7158
	],
	"./global/fr/pagination/content.ts": [
		97158,
		9,
		7158
	],
	"./global/fr/request-custom-module/content": [
		64680,
		9,
		4680
	],
	"./global/fr/request-custom-module/content.tsx": [
		64680,
		9,
		4680
	],
	"./global/fr/select/content": [
		91415,
		9,
		1415
	],
	"./global/fr/select/content.ts": [
		91415,
		9,
		1415
	],
	"./i18n/en": [
		38826,
		3
	],
	"./i18n/en.json": [
		38826,
		3
	],
	"./i18n/fr": [
		49855,
		3,
		9855
	],
	"./i18n/fr-CA": [
		37199,
		3
	],
	"./i18n/fr-CA.json": [
		37199,
		3
	],
	"./i18n/fr.json": [
		49855,
		3,
		9855
	],
	"./pages/en/404/content": [
		27971,
		9,
		7971
	],
	"./pages/en/404/content.tsx": [
		27971,
		9,
		7971
	],
	"./pages/en/banners/b2bLeadGen/content": [
		79839,
		9,
		9839
	],
	"./pages/en/banners/b2bLeadGen/content.tsx": [
		79839,
		9,
		9839
	],
	"./pages/en/banners/freeAccount/content": [
		5017,
		9,
		5017
	],
	"./pages/en/banners/freeAccount/content.tsx": [
		5017,
		9,
		5017
	],
	"./pages/en/banners/inviteTeam/content": [
		79812,
		9,
		9812
	],
	"./pages/en/banners/inviteTeam/content.tsx": [
		79812,
		9,
		9812
	],
	"./pages/en/banners/joinTeam/content": [
		57548,
		9,
		7548
	],
	"./pages/en/banners/joinTeam/content.tsx": [
		57548,
		9,
		7548
	],
	"./pages/en/banners/quarterlyCalculation/content": [
		22661,
		9,
		2661
	],
	"./pages/en/banners/quarterlyCalculation/content.tsx": [
		22661,
		9,
		2661
	],
	"./pages/en/blog/article/content": [
		8059,
		9,
		8059
	],
	"./pages/en/blog/article/content.tsx": [
		8059,
		9,
		8059
	],
	"./pages/en/blog/content": [
		99171,
		9,
		9171
	],
	"./pages/en/blog/content.tsx": [
		99171,
		9,
		9171
	],
	"./pages/en/brand-app-privacy/content": [
		17181,
		9,
		7181
	],
	"./pages/en/brand-app-privacy/content.tsx": [
		17181,
		9,
		7181
	],
	"./pages/en/brands/content": [
		76838,
		9,
		6838
	],
	"./pages/en/brands/content.tsx": [
		76838,
		9,
		6838
	],
	"./pages/en/calculator/content": [
		50400,
		9,
		400
	],
	"./pages/en/calculator/content.tsx": [
		50400,
		9,
		400
	],
	"./pages/en/company/content": [
		30587,
		9,
		587
	],
	"./pages/en/company/content.tsx": [
		30587,
		9,
		587
	],
	"./pages/en/contact/content": [
		86686,
		9,
		6686
	],
	"./pages/en/contact/content.tsx": [
		86686,
		9,
		6686
	],
	"./pages/en/cookies-policy/content": [
		11743,
		9,
		1743
	],
	"./pages/en/cookies-policy/content.tsx": [
		11743,
		9,
		1743
	],
	"./pages/en/customer-stories/content": [
		1938,
		9,
		1938
	],
	"./pages/en/customer-stories/content.tsx": [
		1938,
		9,
		1938
	],
	"./pages/en/faq/content": [
		94524,
		9,
		4524
	],
	"./pages/en/faq/content.tsx": [
		94524,
		9,
		4524
	],
	"./pages/en/forgot-password/content": [
		93427,
		9,
		3427
	],
	"./pages/en/forgot-password/content.tsx": [
		93427,
		9,
		3427
	],
	"./pages/en/home/content": [
		84347,
		9,
		4347
	],
	"./pages/en/home/content.tsx": [
		84347,
		9,
		4347
	],
	"./pages/en/login/content": [
		12157,
		9,
		8292
	],
	"./pages/en/login/content.tsx": [
		12157,
		9,
		8292
	],
	"./pages/en/members/account-settings/content": [
		94482,
		9,
		4482
	],
	"./pages/en/members/account-settings/content.tsx": [
		94482,
		9,
		4482
	],
	"./pages/en/members/admin-challenges-management/content": [
		91077,
		9,
		1077
	],
	"./pages/en/members/admin-challenges-management/content.tsx": [
		91077,
		9,
		1077
	],
	"./pages/en/members/admin-content-overview/content": [
		17797,
		9,
		7797
	],
	"./pages/en/members/admin-content-overview/content.tsx": [
		17797,
		9,
		7797
	],
	"./pages/en/members/admin-edit-company/content": [
		10777,
		9,
		777
	],
	"./pages/en/members/admin-edit-company/content.tsx": [
		10777,
		9,
		777
	],
	"./pages/en/members/admin-payments/content": [
		44993,
		9,
		4993
	],
	"./pages/en/members/admin-payments/content.tsx": [
		44993,
		9,
		4993
	],
	"./pages/en/members/admin-signup/content": [
		2534,
		9,
		2534
	],
	"./pages/en/members/admin-signup/content.tsx": [
		2534,
		9,
		2534
	],
	"./pages/en/members/admin-team-management/content": [
		94108,
		9,
		4108
	],
	"./pages/en/members/admin-team-management/content.tsx": [
		94108,
		9,
		4108
	],
	"./pages/en/members/cancel-membership/content": [
		34153,
		9,
		4153
	],
	"./pages/en/members/cancel-membership/content.tsx": [
		34153,
		9,
		4153
	],
	"./pages/en/members/challenge/content": [
		38990,
		9,
		8990
	],
	"./pages/en/members/challenge/content.tsx": [
		38990,
		9,
		8990
	],
	"./pages/en/members/challenges/content": [
		6247,
		9,
		6247
	],
	"./pages/en/members/challenges/content.tsx": [
		6247,
		9,
		6247
	],
	"./pages/en/members/choose-group-modules/content": [
		65394,
		9,
		5394
	],
	"./pages/en/members/choose-group-modules/content.tsx": [
		65394,
		9,
		5394
	],
	"./pages/en/members/choose-personalized-modules/content": [
		36669,
		9,
		6669
	],
	"./pages/en/members/choose-personalized-modules/content.tsx": [
		36669,
		9,
		6669
	],
	"./pages/en/members/climate-class-view/content": [
		23365,
		9,
		3365
	],
	"./pages/en/members/climate-class-view/content.tsx": [
		23365,
		9,
		3365
	],
	"./pages/en/members/climate-class/content": [
		35126,
		9,
		5126
	],
	"./pages/en/members/climate-class/content.tsx": [
		35126,
		9,
		5126
	],
	"./pages/en/members/climate-journey-404/content": [
		20430,
		9,
		430
	],
	"./pages/en/members/climate-journey-404/content.tsx": [
		20430,
		9,
		430
	],
	"./pages/en/members/climate-journey/content": [
		1133,
		9,
		1133
	],
	"./pages/en/members/climate-journey/content.tsx": [
		1133,
		9,
		1133
	],
	"./pages/en/members/connect-chat-app/content": [
		81132,
		9,
		1132
	],
	"./pages/en/members/connect-chat-app/content.tsx": [
		81132,
		9,
		1132
	],
	"./pages/en/members/content-view/content": [
		91437,
		9,
		1437
	],
	"./pages/en/members/content-view/content.tsx": [
		91437,
		9,
		1437
	],
	"./pages/en/members/d2c-dashboard/content": [
		38069,
		9,
		8069
	],
	"./pages/en/members/d2c-dashboard/content.tsx": [
		38069,
		9,
		8069
	],
	"./pages/en/members/employee-dashboard/content": [
		36347,
		9,
		6347
	],
	"./pages/en/members/employee-dashboard/content.tsx": [
		36347,
		9,
		6347
	],
	"./pages/en/members/employee-invite/content": [
		16166,
		9,
		6166
	],
	"./pages/en/members/employee-invite/content.tsx": [
		16166,
		9,
		6166
	],
	"./pages/en/members/migration-calculator-entry/content": [
		62433,
		9,
		2433
	],
	"./pages/en/members/migration-calculator-entry/content.tsx": [
		62433,
		9,
		2433
	],
	"./pages/en/members/onboarding-calculator-completed/content": [
		49929,
		9,
		9929
	],
	"./pages/en/members/onboarding-calculator-completed/content.tsx": [
		49929,
		9,
		9929
	],
	"./pages/en/members/org-dashboard/content": [
		65950,
		9,
		5950
	],
	"./pages/en/members/org-dashboard/content.tsx": [
		65950,
		9,
		5950
	],
	"./pages/en/members/personal-and-work-calculator-entry/content": [
		34093,
		9,
		4093
	],
	"./pages/en/members/personal-and-work-calculator-entry/content.tsx": [
		34093,
		9,
		4093
	],
	"./pages/en/members/personal-calculator-entry/content": [
		37084,
		9,
		7084
	],
	"./pages/en/members/personal-calculator-entry/content.tsx": [
		37084,
		9,
		7084
	],
	"./pages/en/members/point-redemptions/content": [
		39854,
		9,
		9854
	],
	"./pages/en/members/point-redemptions/content.tsx": [
		39854,
		9,
		9854
	],
	"./pages/en/members/points-overview/content": [
		78756,
		9,
		8756
	],
	"./pages/en/members/points-overview/content.tsx": [
		78756,
		9,
		8756
	],
	"./pages/en/members/quarterly-calculator-completed/content": [
		6243,
		9,
		6243
	],
	"./pages/en/members/quarterly-calculator-completed/content.tsx": [
		6243,
		9,
		6243
	],
	"./pages/en/members/review-selected-modules/content": [
		3970,
		9,
		3970
	],
	"./pages/en/members/review-selected-modules/content.tsx": [
		3970,
		9,
		3970
	],
	"./pages/en/members/teams-instructions/content": [
		98036,
		9,
		8036
	],
	"./pages/en/members/teams-instructions/content.tsx": [
		98036,
		9,
		8036
	],
	"./pages/en/members/work-calculator-entry/content": [
		86526,
		9,
		6526
	],
	"./pages/en/members/work-calculator-entry/content.tsx": [
		86526,
		9,
		6526
	],
	"./pages/en/no-permission/content": [
		58987,
		9,
		8987
	],
	"./pages/en/no-permission/content.tsx": [
		58987,
		9,
		8987
	],
	"./pages/en/pdf/content": [
		68637,
		9,
		8637
	],
	"./pages/en/pdf/content.tsx": [
		68637,
		9,
		8637
	],
	"./pages/en/privacy/content": [
		40463,
		9,
		463
	],
	"./pages/en/privacy/content.tsx": [
		40463,
		9,
		463
	],
	"./pages/en/product/content": [
		18431,
		9,
		8431
	],
	"./pages/en/product/content.tsx": [
		18431,
		9,
		8431
	],
	"./pages/en/projects/content": [
		35467,
		9,
		5467
	],
	"./pages/en/projects/content.tsx": [
		35467,
		9,
		5467
	],
	"./pages/en/receipt/content": [
		12435,
		9,
		2435
	],
	"./pages/en/receipt/content.tsx": [
		12435,
		9,
		2435
	],
	"./pages/en/receipts/content": [
		3053,
		9,
		3053
	],
	"./pages/en/receipts/content.tsx": [
		3053,
		9,
		3053
	],
	"./pages/en/reserve-demo/content": [
		76744,
		9,
		6744
	],
	"./pages/en/reserve-demo/content.tsx": [
		76744,
		9,
		6744
	],
	"./pages/en/reset-password/content": [
		8023,
		9,
		8023
	],
	"./pages/en/reset-password/content.tsx": [
		8023,
		9,
		8023
	],
	"./pages/en/security-commitment/content": [
		68275,
		9,
		8275
	],
	"./pages/en/security-commitment/content.tsx": [
		68275,
		9,
		8275
	],
	"./pages/en/single-project/content": [
		76821,
		9,
		6821
	],
	"./pages/en/single-project/content.tsx": [
		76821,
		9,
		6821
	],
	"./pages/en/slack-landing-page/content": [
		61014,
		9,
		1014
	],
	"./pages/en/slack-landing-page/content.tsx": [
		61014,
		9,
		1014
	],
	"./pages/en/terms/content": [
		58136,
		9,
		8136
	],
	"./pages/en/terms/content.tsx": [
		58136,
		9,
		8136
	],
	"./pages/fr/404/content": [
		70654,
		9,
		654
	],
	"./pages/fr/404/content.tsx": [
		70654,
		9,
		654
	],
	"./pages/fr/banners/freeAccount/content": [
		49752,
		9,
		9752
	],
	"./pages/fr/banners/freeAccount/content.tsx": [
		49752,
		9,
		9752
	],
	"./pages/fr/banners/inviteTeam/content": [
		21188,
		9,
		1188
	],
	"./pages/fr/banners/inviteTeam/content.tsx": [
		21188,
		9,
		1188
	],
	"./pages/fr/banners/joinTeam/content": [
		41179,
		9,
		1179
	],
	"./pages/fr/banners/joinTeam/content.tsx": [
		41179,
		9,
		1179
	],
	"./pages/fr/banners/quarterlyCalculation/content": [
		58446,
		9,
		8446
	],
	"./pages/fr/banners/quarterlyCalculation/content.tsx": [
		58446,
		9,
		8446
	],
	"./pages/fr/brands/content": [
		25485,
		9,
		5485
	],
	"./pages/fr/brands/content.tsx": [
		25485,
		9,
		5485
	],
	"./pages/fr/calculator/content": [
		37222,
		9,
		2134
	],
	"./pages/fr/calculator/content.tsx": [
		37222,
		9,
		2134
	],
	"./pages/fr/company/content": [
		56099,
		9,
		6099
	],
	"./pages/fr/company/content.tsx": [
		56099,
		9,
		6099
	],
	"./pages/fr/contact/content": [
		77667,
		9,
		7667
	],
	"./pages/fr/contact/content.tsx": [
		77667,
		9,
		7667
	],
	"./pages/fr/cookies-policy/content": [
		17656,
		9,
		7656
	],
	"./pages/fr/cookies-policy/content.tsx": [
		17656,
		9,
		7656
	],
	"./pages/fr/customer-stories/content": [
		36763,
		9,
		6763
	],
	"./pages/fr/customer-stories/content.tsx": [
		36763,
		9,
		6763
	],
	"./pages/fr/faq/content": [
		48233,
		9,
		8233
	],
	"./pages/fr/faq/content.tsx": [
		48233,
		9,
		8233
	],
	"./pages/fr/forgot-password/content": [
		15062,
		9,
		5062
	],
	"./pages/fr/forgot-password/content.tsx": [
		15062,
		9,
		5062
	],
	"./pages/fr/home/content": [
		77285,
		9,
		7285
	],
	"./pages/fr/home/content.tsx": [
		77285,
		9,
		7285
	],
	"./pages/fr/login/content": [
		52957,
		9,
		2957
	],
	"./pages/fr/login/content.tsx": [
		52957,
		9,
		2957
	],
	"./pages/fr/members/account-settings/content": [
		30904,
		9,
		904
	],
	"./pages/fr/members/account-settings/content.tsx": [
		30904,
		9,
		904
	],
	"./pages/fr/members/admin-challenges-management/content": [
		80677,
		9,
		677
	],
	"./pages/fr/members/admin-challenges-management/content.tsx": [
		80677,
		9,
		677
	],
	"./pages/fr/members/admin-content-overview/content": [
		96808,
		9,
		6808
	],
	"./pages/fr/members/admin-content-overview/content.tsx": [
		96808,
		9,
		6808
	],
	"./pages/fr/members/admin-edit-company/content": [
		72671,
		9,
		2671
	],
	"./pages/fr/members/admin-edit-company/content.tsx": [
		72671,
		9,
		2671
	],
	"./pages/fr/members/admin-payments/content": [
		49828,
		9,
		9828
	],
	"./pages/fr/members/admin-payments/content.tsx": [
		49828,
		9,
		9828
	],
	"./pages/fr/members/admin-signup/content": [
		36564,
		9,
		6564
	],
	"./pages/fr/members/admin-signup/content.tsx": [
		36564,
		9,
		6564
	],
	"./pages/fr/members/admin-team-management/content": [
		86090,
		9,
		6090
	],
	"./pages/fr/members/admin-team-management/content.tsx": [
		86090,
		9,
		6090
	],
	"./pages/fr/members/cancel-membership/content": [
		2371,
		9,
		2371
	],
	"./pages/fr/members/cancel-membership/content.tsx": [
		2371,
		9,
		2371
	],
	"./pages/fr/members/challenge/content": [
		81496,
		9,
		9954
	],
	"./pages/fr/members/challenge/content.tsx": [
		81496,
		9,
		9954
	],
	"./pages/fr/members/challenges/content": [
		87974,
		9,
		7974
	],
	"./pages/fr/members/challenges/content.tsx": [
		87974,
		9,
		7974
	],
	"./pages/fr/members/choose-group-modules/content": [
		85465,
		9,
		5465
	],
	"./pages/fr/members/choose-group-modules/content.tsx": [
		85465,
		9,
		5465
	],
	"./pages/fr/members/choose-personalized-modules/content": [
		87966,
		9,
		7966
	],
	"./pages/fr/members/choose-personalized-modules/content.tsx": [
		87966,
		9,
		7966
	],
	"./pages/fr/members/climate-class-view/content": [
		99608,
		9,
		9608
	],
	"./pages/fr/members/climate-class-view/content.tsx": [
		99608,
		9,
		9608
	],
	"./pages/fr/members/climate-class/content": [
		94695,
		9,
		4695
	],
	"./pages/fr/members/climate-class/content.tsx": [
		94695,
		9,
		4695
	],
	"./pages/fr/members/connect-chat-app/content": [
		47977,
		9,
		7977
	],
	"./pages/fr/members/connect-chat-app/content.tsx": [
		47977,
		9,
		7977
	],
	"./pages/fr/members/content-view/content": [
		7910,
		9,
		7910
	],
	"./pages/fr/members/content-view/content.tsx": [
		7910,
		9,
		7910
	],
	"./pages/fr/members/employee-dashboard/content": [
		1757,
		9,
		1757
	],
	"./pages/fr/members/employee-dashboard/content.tsx": [
		1757,
		9,
		1757
	],
	"./pages/fr/members/employee-invite/content": [
		33834,
		9,
		3834
	],
	"./pages/fr/members/employee-invite/content.tsx": [
		33834,
		9,
		3834
	],
	"./pages/fr/members/migration-calculator-entry/content": [
		87229,
		9,
		7229
	],
	"./pages/fr/members/migration-calculator-entry/content.tsx": [
		87229,
		9,
		7229
	],
	"./pages/fr/members/onboarding-calculator-completed/content": [
		92382,
		9,
		2382
	],
	"./pages/fr/members/onboarding-calculator-completed/content.tsx": [
		92382,
		9,
		2382
	],
	"./pages/fr/members/org-dashboard/content": [
		35291,
		9,
		5291
	],
	"./pages/fr/members/org-dashboard/content.tsx": [
		35291,
		9,
		5291
	],
	"./pages/fr/members/personal-and-work-calculator-entry/content": [
		1705,
		9,
		1705
	],
	"./pages/fr/members/personal-and-work-calculator-entry/content.tsx": [
		1705,
		9,
		1705
	],
	"./pages/fr/members/personal-calculator-entry/content": [
		93764,
		9,
		3764
	],
	"./pages/fr/members/personal-calculator-entry/content.tsx": [
		93764,
		9,
		3764
	],
	"./pages/fr/members/point-redemptions/content": [
		98697,
		9,
		8697
	],
	"./pages/fr/members/point-redemptions/content.tsx": [
		98697,
		9,
		8697
	],
	"./pages/fr/members/points-overview/content": [
		45347,
		9,
		5347
	],
	"./pages/fr/members/points-overview/content.tsx": [
		45347,
		9,
		5347
	],
	"./pages/fr/members/quarterly-calculator-completed/content": [
		79270,
		9,
		9270
	],
	"./pages/fr/members/quarterly-calculator-completed/content.tsx": [
		79270,
		9,
		9270
	],
	"./pages/fr/members/review-selected-modules/content": [
		5235,
		9,
		5235
	],
	"./pages/fr/members/review-selected-modules/content.tsx": [
		5235,
		9,
		5235
	],
	"./pages/fr/members/teams-instructions/content": [
		9117,
		9,
		9117
	],
	"./pages/fr/members/teams-instructions/content.tsx": [
		9117,
		9,
		9117
	],
	"./pages/fr/members/work-calculator-entry/content": [
		58460,
		9,
		8460
	],
	"./pages/fr/members/work-calculator-entry/content.tsx": [
		58460,
		9,
		8460
	],
	"./pages/fr/no-permission/content": [
		87412,
		9,
		7412
	],
	"./pages/fr/no-permission/content.tsx": [
		87412,
		9,
		7412
	],
	"./pages/fr/privacy/content": [
		40343,
		9,
		343
	],
	"./pages/fr/privacy/content.tsx": [
		40343,
		9,
		343
	],
	"./pages/fr/product/content": [
		64808,
		9,
		4808
	],
	"./pages/fr/product/content.tsx": [
		64808,
		9,
		4808
	],
	"./pages/fr/projects/content": [
		76577,
		9,
		6577
	],
	"./pages/fr/projects/content.tsx": [
		76577,
		9,
		6577
	],
	"./pages/fr/receipts/content": [
		6687,
		9,
		6687
	],
	"./pages/fr/receipts/content.tsx": [
		6687,
		9,
		6687
	],
	"./pages/fr/reserve-demo/content": [
		34968,
		9,
		4968
	],
	"./pages/fr/reserve-demo/content.tsx": [
		34968,
		9,
		4968
	],
	"./pages/fr/reset-password/content": [
		52932,
		9,
		2932
	],
	"./pages/fr/reset-password/content.tsx": [
		52932,
		9,
		2932
	],
	"./pages/fr/single-project/content": [
		53098,
		9,
		3098
	],
	"./pages/fr/single-project/content.tsx": [
		53098,
		9,
		3098
	],
	"./pages/fr/terms/content": [
		4958,
		9,
		4958
	],
	"./pages/fr/terms/content.tsx": [
		4958,
		9,
		4958
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42835;
module.exports = webpackAsyncContext;